import type { OpenAPI } from "simplydo/interfaces";

/** Organisation from getByCode / urlOrganisation store — includes resolved logo URLs at runtime. */
export type UrlOrganisation = OpenAPI.Schemas["Organisation"] &
  OpenAPI.Schemas["organisationDarkLogoUrl"];

export type LoginResponse = OpenAPI.POST<"/accounts/login">["response"];

export type LoginOtpRequiredResponse = {
  otpRequired: true;
  otpExchangeToken?: string;
  exchangeToken?: string;
  userHasRecoveryCodes?: boolean;
};

export type MagicLoginEmailResponse = {
  securityPhrase: string;
  exchangeToken: string;
};

export function isLoginOtpRequired(
  data: LoginResponse,
): data is LoginOtpRequiredResponse {
  return "otpRequired" in data && data.otpRequired === true;
}

export function isMagicLoginEmailResponse(
  data: unknown,
): data is MagicLoginEmailResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "securityPhrase" in data &&
    "exchangeToken" in data
  );
}

export function organisationLogoUrl(
  organisation: UrlOrganisation | null | undefined,
): string | undefined {
  return organisation?.darkLogoUrl;
}
